import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  adminActivateOrganization,
  adminCreateNewOrganization,
  adminDeactivateOrganization,
  adminEditOrganization,
  adminSearchOrganizations,
  getAdminOrganizationDetails,
} from '@api/adminOrganizations';
import {
  IAdminOrganizationCreateNewPayload,
  IAdminOrganizationDetails,
  IAdminOrganizationEditPayload,
  IAdminOrganizationsSearchResult,
} from '@interfaces/adminOrganizations';
import { IFetchListRequestPayload } from '@interfaces/common';

export const handleAdminSearchOrganizations = createAsyncThunk<
  AxiosResponse<IAdminOrganizationsSearchResult>,
  IFetchListRequestPayload
>('adminSearchOrganizations', adminSearchOrganizations);

export const handleGetAdminOrganizationDetails = createAsyncThunk<
  AxiosResponse<IAdminOrganizationDetails>,
  number
>('getAdminOrganizationDetails', getAdminOrganizationDetails);

export const handleAdminCreateNewOrganization = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminOrganizationCreateNewPayload
>('adminCreateNewOrganization', adminCreateNewOrganization);

export const handleAdminEditOrganization = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminOrganizationEditPayload
>('adminEditOrganization', adminEditOrganization);

export const handleAdminActivateOrganization = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminActivateOrganization', adminActivateOrganization);

export const handleAdminDeactivateOrganization = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('adminDeactivateOrganization', adminDeactivateOrganization);
